import { getQuiz, getQuizCorrectAnswer } from '@/calls/quiz';

const stories = {
  namespaced: true,
  state: {
    requests: 0,
    requestsDetail: 0,
    correctAnswer: undefined,
    item: {
      /* question: undefined,
      answers: [{ id: 1, text: 'a', correct: true }, { id: 2, text: 'b' }, { id: 3, text: 'c' }],
      text: undefined */
    }
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    increaseRequests(state, type) {
      if (type) {
        state[type] += 1;
        return;
      }

      state.requests += 1;
    },
    decreaseRequests(state, type) {
      if (type) {
        state[type] -= 1;
        return;
      }

      state.requests -= 1;
    }
  },
  actions: {
    async reset({ commit }) {
      commit('increaseRequests');
      commit('setItem', []);
      commit('decreaseRequests');
    },
    async get({ commit }, { id, loc }) {
      console.log(id, loc)
      commit('increaseRequests');
      try {
        const timestamp = Date.now();
        const response = await getQuiz(id, timestamp, loc);
        commit('setItem', response.quiz);
      } catch (e) {
        commit('setItem', []);
      }
      commit('decreaseRequests');
    },
    async getQuizCorrectAnswer({ commit }, {
 storyId, answer, score, loc
}) {
      commit('increaseRequests');
      try {
        const timestamp = Date.now();
        return await getQuizCorrectAnswer(storyId, answer, timestamp, score, loc);
      } catch (e) {
        // nothing to do
      }
      commit('decreaseRequests');
      return false;
    },
  }
};

export default stories;
